<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <div class="footer-logo">
            <img class="logo-icon" src="@/assets/images/optimized/logo0.webp" />
            <!-- <div class="logo-text">贸易</div> -->
          </div>
          <p class="footer-slogan">{{ $t("footer.slogan1") }}<br />{{ $t("footer.slogan2") }}</p>
          <p class="footer-motto">{{ $t("footer.motto") }}</p>
        </div>

        <div class="footer-links">
          <div class="footer-column">
            <h4>{{ $t("footer.quickLinks") }}</h4>
            <ul>
              <li>
                <a href="#home">{{ $t("nav.home") }}</a>
              </li>
              <li>
                <a href="#business">{{ $t("nav.business") }}</a>
              </li>
              <li>
                <a href="#advantages">{{ $t("nav.advantages") }}</a>
              </li>
              <li>
                <a href="#about">{{ $t("nav.about") }}</a>
              </li>
            </ul>
          </div>

          <div class="footer-column">
            <h4>{{ $t("footer.contact") }}</h4>
            <ul>
              <li><i class="el-icon-location"></i> {{ $t("footer.address") }}</li>
              <li><i class="el-icon-phone"></i> {{ $t("footer.phone") }}</li>
              <li><i class="el-icon-message"></i> {{ $t("footer.email") }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p>{{ $t("footer.copyright") }}</p>
        <div class="back-to-top" @click="scrollToTop">
          <i class="el-icon-arrow-up"></i>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.footer {
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  color: white;
  padding: 60px 0 30px;
  position: relative;
}

.footer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #3194b2, transparent);
}

.footer-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 60px;
  margin-bottom: 50px;
}

.footer-brand {
  max-width: 500px;
}

.footer-logo {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.footer-logo .logo-icon {
  /* width: 50px; */
  height: 180px;
  /* background: linear-gradient(135deg, #3194b2, #31a7d2); */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  border-radius: 10px;
  margin-left: -10px;
}

.footer-logo .logo-text {
  color: white;
  font-size: 26px;
  font-weight: 600;
}

.footer-slogan {
  color: rgba(255, 255, 255, 0.95);
  font-size: 18px;
  line-height: 1.8;
  margin-bottom: 15px;
  font-weight: 300;
}

.footer-motto {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-style: italic;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}

.footer-column h4 {
  color: white;
  font-size: 18px;
  margin-bottom: 20px;
  font-weight: 600;
}

.footer-column ul {
  list-style: none;
}

.footer-column ul li {
  margin-bottom: 12px;
}

.footer-column ul li a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  display: inline-block;
}

.footer-column ul li a:hover {
  color: #43b4ea;
  padding-left: 5px;
}

.footer-column ul li i {
  margin-right: 8px;
  color: #3194b2;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
}

.back-to-top {
  width: 45px;
  height: 45px;
  background: rgba(49, 148, 178, 0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid rgba(49, 148, 178, 0.4);
}

.back-to-top:hover {
  background: #3194b2;
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(49, 148, 178, 0.5);
}

.back-to-top i {
  font-size: 20px;
  color: white;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .footer-links {
    grid-template-columns: 1fr;
  }

  .footer-bottom {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  .footer-logo .logo-icon {
    /* width: 50px; */
    height: 160px;
    /* background: linear-gradient(135deg, #3194b2, #31a7d2); */
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    border-radius: 10px;
    margin-left: -10px;
  }
}
</style>
